import { formatBoxTruckDimensions, formatBoxTruckDockHeight, NearbyBoxTruckDriver } from '@numeo/types-core'
import { DriverRoadDistanceState } from '../types/roadDistance'
import { formatMilesOut, resolveMilesOut } from './roadDistance'

export const buildDriverTemplateVariables = (
    selectedDriver: NearbyBoxTruckDriver | null,
    nearestDriver: NearbyBoxTruckDriver | undefined,
    selectedRoadDistance: DriverRoadDistanceState
): Record<string, string | null> => {
    const driver = selectedDriver ?? nearestDriver
    // miles_out stays SELECTION-only — the nearest driver is a fallback for unit details, never for the
    // distance the broker is quoted. For the picked driver it always resolves to something: the routed
    // miles, or the direct estimate while that route is pending, has failed, or has been outrun by a newer
    // fix. Formatted WITHOUT the ≈ — see formatMilesOut; the marker is for the operator's table only.
    // Whole miles: the broker reads "156 mi", not "155.9 mi".
    const milesOut = selectedDriver
        ? formatMilesOut(resolveMilesOut(selectedDriver.lastSeenAt, selectedDriver.proximityDistanceMi, selectedRoadDistance), 0)
        : null
    return {
        driver_name: driver?.name ?? null,
        driver_phone: driver?.phone ?? null,
        driver_equipment: driver?.equipment ?? null,
        miles_out: milesOut,
        driver_dimensions: formatBoxTruckDimensions(driver?.cargoDimensions) ?? null,
        driver_payload: driver?.maxCargoWeightLbs != null ? `${driver.maxCargoWeightLbs.toLocaleString()} lbs` : null,
        dock_height_ramps: formatBoxTruckDockHeight(driver?.dockHeightRamps),
        equipment_capabilities: driver?.equipmentCapabilities?.length ? driver.equipmentCapabilities.join(', ') : null,
        driver_location: driver ? [driver.city, driver.state].filter(Boolean).join(', ') || null : null,
        truck_number: driver?.truckNumber ?? null,
    }
}
